<template>
  <div class="main-box">
     <van-nav-bar
        title="就诊人列表"
        left-arrow
         left-text="返回"
        @click-left="onClickLeft"
      />
    <div class="cell">
      <div
        class="item"
        size="large"
        v-for="(item, index) in cardList"
        :key="index"
        @click="goCarddetails(item)"
      >
        <div class="cell_item">
          <div class="title">{{ item.PatientName }}</div>
          <div class="value">{{ item.PatientID }}</div>
        </div>
        <div class="cell_item">
          <div class="value">tel: {{ item.Mobile }}</div>
          <!-- class="btn_mini_style" -->
          <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click.stop="isremoveCardNo(item.PatientID)"
              >解绑</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <van-empty
      v-if="cardList.length === 0 && !isLoad"
      image="https://account.kmmds.top/datainfo_pic/error.png"
      description="暂无相关就诊卡信息,请绑定新卡"
    />
    <div class="Btn_style" v-if="!isLoad">
      <van-button
        class="btn"
        type="info"
        size="large"
        round
        @click.stop="$router.push('/patient_card_bind_D')"
        text="添加就诊卡"
      >
      </van-button>
    </div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
export default {
  mixins: [setOptions],
  data() {
    return {
      path:null,
      cardList: [],
      isLoad: true,
      medCardNo: "",
      test:{a:0.01},
      test:"2020-11-25T17:36:26.000Z",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getmedicalcard();
  },
   beforeRouteEnter(to, from, next) {
    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  methods: {  
    renderTime(date) {
  var dateee = new Date(date).toJSON();
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
},
    //跳转详情页
    goCarddetails(item) {
      console.log(item);
      let userdata = item;
      this.$router.push({
        path: "/patient_card_details_D",
        query: {
          userdata,
        },
      }),
        console.log(userdata);
    },
    //确认事件
    isremoveCardNo(medCardNo) {
      this.$dialog
        .confirm({
          message: "是否解除绑卡？",
        })
        .then(() => {
          // on confirm
          this.removemedCardNo(medCardNo);
        })
        .catch(() => {
          // on cancel
        });
    },
    onClickLeft(){
       this.$router.push("/index")
    },
    //解绑
    async removemedCardNo(medCardNo) {
      this.$showLoad()
      let url = "/medicalcard/removeBindcard";
      let res_data = {
        medCardNo: medCardNo,
      };
      await this.$axios_request.axios_request_body(
        "nodeserver",
        url,
        "POST",
        res_data,
        (data) => {
          if (data.data.state && data.data.state == "1") {
             this.getmedicalcard();
             this.$hideLoad()
          } else {
            this.$hideLoad()
            this.$toast.fail("绑卡失败");
          }
        }
      );
      // this.isLoad = true
    },
    async getmedicalcard() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/getclientcardlist";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // console.log(data);
            this.cardList = [...data.data];
            console.log(this.cardList)
            if (this.cardList.length >= 10) {
              this.isLoad = true;
            } else {
              this.isLoad = false;
            }
            console.log(data.data);
            this.$hideLoad();
            // Dialog.alert({
            //   message:
            //     "该公众号目前数据均为测试数据，你所录入的数据也将录入测试数据",
            // }).then(() => {
            //   // on close
            // });
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background: white;

  .nav {
    margin-bottom: 8px;
  }
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    .cell_item {
      display: flex;
      flex-direction: row;
      line-height: 40px;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 10px;
      .title {
        font-size: 18px;
        color: #323233;
      }
      .value {
        font-size: 16px;
        color: #555;
      }
      .label {
        font-size: 15px;
        color: #999;
      }
    }
    // margin-top: 15px;
  }
  .item {
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 16px;
    &::after {
      border-bottom: 0;
    }
    margin-bottom: 15px;
    background-color: #f7f8fa;
    box-shadow: 0 8px 12px #ebedf0;
    border-radius: 8px;
  }

  .btn-box {
    .btn {
      margin-left: 40px;
    }
  }
}
.cell_box {
  display: flex;
  flex-direction: column;
}
.mar {
  margin-top: 10px;
}
.submit {
  margin: 55px 20px 25px 20px;
}
.Btn_style {
  width: 100%;
  // margin: 0px auto;
  position: fixed;
  bottom: 0vh;
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-items: center;
  height: 70px;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .btn {
    width: 95%;
    letter-spacing: 10px;
    font-size: 16px;
    margin: 10px auto;
    background-color:#5B8DF6;
  }
}
.btn_mini_style {
  width: 80px;
  height: 25px;
  letter-spacing: 7px;
}
 .van-button--round {
  border-radius: 10px;
}
</style>